// src/components/BookStorePage.jsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./book.css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Nav from "./Nav";
import daddu from "../assets/daddu.jpg";
import API_BASE from "../api/api";
import toast from "react-hot-toast";
import { FaCheckCircle, FaAward, FaTruck } from "react-icons/fa";


export default function BookStorePage() {
  const navigate = useNavigate();
  const location = useLocation();

  const [books, setBooks] = useState([]);
  const [cart, setCart] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const booksPerPage = 12;
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOption, setSortOption] = useState("relevance");

useEffect(() => {
  fetch(`${API_BASE}/getbook.php?limit=1000`) // 🔥 FORCE ALL DATA
    .then((res) => res.json())
    .then((data) => {
      if (data.status === "success" && Array.isArray(data.data)) {
        setBooks(
          data.data.map((b) => ({
            ...b,
            id: b.id ?? b.book_id,
            title: b.title || "",
          }))
        );
      } else {
        console.error("❌ API Error:", data.message || "Invalid response");
        setBooks([]);
      }
    })
    .catch((err) => {
      console.error("❌ Fetch failed:", err);
      setBooks([]);
    });
}, []);

  useEffect(() => {
    // hydrate cart from localStorage if present (keeps UI responsive)
    try {
      const stored = JSON.parse(localStorage.getItem("cartItems") || "[]");
      setCart(stored);
    } catch (e) {
      setCart([]);
    }
  }, []);

const addToCart = async (book) => {

  // ✅ Pehle session check karo
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  if (!isLoggedIn) {
    toast.error("Please login first");
    navigate("/login", { state: { from: location.pathname } });
    return;
  }

  const payload = {
    product_id: book.id,
    quantity: 1,
  };

  try {
    const res = await fetch(`${API_BASE}/addcart.php`, {
      method: "POST",
      credentials: "include", // ✅ MUST for session
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

   const text = await res.text();
console.log("RAW RESPONSE:", text);

let data;
try {
  data = JSON.parse(text);
} catch (e) {
  toast.error("Invalid server response");
  return;
}
    console.log("ADD CART:", data);

// 🔴 CASE 1: NOT LOGGED IN
    if (!data.success && (
      data.message === "Not logged in" ||
      data.message === "Session expired, please login again"  // ✅ config.php ka naya message
    )) {
      toast.error("Please login first");
      navigate("/login", { state: { from: location.pathname } });
      return;
    }

    // 🔴 CASE 2: USER NOT FOUND (SESSION EXPIRED)
    if (!data.success && data.message === "User not found, please login again") {  // ✅ updated message
      localStorage.clear();
      navigate("/login");
      return;
    }

    // ✅ SUCCESS
    if (data.success) {
      toast.success("Book added to cart");

      window.dispatchEvent(new Event("cartUpdated"));

      // 👉 सीधे cart page
      navigate("/cart");
    } else {
      toast.error(data.message || "Something went wrong");
    }

  } catch (err) {
    console.error("Add cart error:", err);
    toast.error("Network error");
  }
};

  const normalizedQuery = searchQuery.toLowerCase().trim();

  const filteredBooks = books.filter((book) => {
    return (
      (book.title || "").toLowerCase().includes(normalizedQuery) ||
      (book.highlights || "").toLowerCase().includes(normalizedQuery)
    );
  });

  const sortedBooks = [...filteredBooks].sort((a, b) => {
    const pa = Number(a.price || 0);
    const pb = Number(b.price || 0);
    if (sortOption === "low") return pa - pb;
    if (sortOption === "high") return pb - pa;
    return 0;
  });

  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = sortedBooks.slice(indexOfFirstBook, indexOfLastBook);
  const totalPages = Math.ceil(filteredBooks.length / booksPerPage) || 1;

  return (
    <>
      <Nav />
      <Navbar />

      {/* Redesigned Hero Banner */}
      <section className="books-hero-banner">
        <div className="books-hero-overlay">
          <div className="books-hero-container">
            <h1 className="hero-title">Explore Indian Classical Music Literature</h1>
            <p className="hero-subtitle">
              Authentic theoretical and practical treatises on Vocal, Sitar, Tabla, and Hindustani music history authored by renowned scholars, tailored for academic syllabi.
            </p>
            <div className="hero-features-strip">
              <div className="hero-feature-item">
                <FaCheckCircle className="feat-icon" />
                <span>100% Authentic Syllabi</span>
              </div>
              <div className="hero-feature-item">
                <FaAward className="feat-icon" />
                <span>Authored by Sangeetacharya</span>
              </div>
              <div className="hero-feature-item">
                <FaTruck className="feat-icon" />
                <span>Nationwide Express Delivery</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="bookstore-container">
        <div className="bookstore-main full-width">
          <div className="bookstore-header">
            <h2 className="bookstore-title">All Publications</h2>

            <div className="search-sort-container">
              <input
                type="text"
                placeholder="Search Books..."
                className="book-search-input"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                }}
              />

              <select
                className="sort-dropdown"
                value={sortOption}
                onChange={(e) => {
                  setSortOption(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="relevance">Sort By: Relevance</option>
                <option value="low">Price: Low to High</option>
                <option value="high">Price: High to Low</option>
              </select>
            </div>
          </div>

          {/* Books */}
          <div className="book-grid">
            {currentBooks.length > 0 ? (
              currentBooks.map((book) => {
                const id = book.id ?? book.title;
                const author =
                  (book.highlights && book.highlights.trim()) ||
                  book.author ||
                  "Unknown";
                const imagePath = book.image
                  ? `https://sangitshreeprakashan.com/backend/${book.image.replace(
                      "../",
                      ""
                    )}`
                  : daddu;

                return (
                  <div key={id} className="book-card">
                    <div className="book-row">
                      <div className="book-img-wrapper">
                        <Link to={`/book/${id}`}>
                          <img
                            src={imagePath}
                            alt={book.title}
                            className="book-img"
                          />
                        </Link>
                      </div>

                      <div className="book-info-box">
                        <div className="book-info-row">
                          <span className="book-info-label">Title</span>
                          <span className="book-info-value">{book.title}</span>
                        </div>

                        <div className="book-info-row">
                          <span className="book-info-label">Author</span>
                          <span className="book-info-value">{author}</span>
                        </div>

                        <div className="book-info-row">
                          <span className="book-info-label">Price</span>
                          <span className="book-info-value">₹{book.price}</span>
                        </div>

                        <div className="btn-row">
                          <button
                            className="btn-buy"
                            onClick={() => addToCart(book)}
                          >
                            Add to Cart
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="no-books">📦 No books available at the moment.</p>
            )}
          </div>

          {/* Pagination */}
          <div className="pagination">
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => {
                  setCurrentPage(i + 1);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className={`page-button ${currentPage === i + 1 ? "active" : ""}`}
              >
                {i + 1}
              </button>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
